import styled from 'styled-components';
import { motion } from "framer-motion";

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10001;
`;

export const ImageContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  
  width: 90%;
  height: 90%;
  text-align: center;
`;

export const MotionImage = styled(motion.img)`
  max-width: 100%;
  max-height: 100%;
  border-radius: 4px;
`;

export const ArrowButton = styled.button`
  position: absolute;
  top: 0;
  bottom: 0;
  width: 60px;
  background: transparent;
  border: none;
  color: white;
  font-size: 2rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.3s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.2);
  }

  &:focus {
    outline: none;
  }
`;

export const LeftArrow = styled(ArrowButton)`
  left: 0;
`;

export const RightArrow = styled(ArrowButton)`
  right: 0;
`;

export const StyledText = styled.div<{isImageCaption?: boolean}>`
  font-family: Inter, sans-serif;
  font-weight: 400;
  font-size: 18px;
  line-height: 120%;

  color: #FFFFFF;
`

export const CloseButton = styled.button`
  position: absolute;
  top: 0;
  right: 0;
  width: 60px;
  height: 60px;
  background: transparent;
  border: none;
  color: white;
  font-size: 2rem;
  line-height: 2rem;
  cursor: pointer;
  transition: background 0.3s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.2);
  }

  &:focus {
    outline: none;
  }
`;
